export enum E_MasterListName {
  ALLERGY = 'AllergyList',
  ALTABLE = 'AltableOptionList',
  DESTINATION = 'DestinationList',
  DIAGNOSIS = 'DiagnosisList',
  DOCTOR_LIST = 'DoctorList',
  DOCTOR_TYPE = 'DoctorTypeList',
  INSULATION = 'InsulationList',
  MOBILITY = 'MobilityOptionList',
  ORIGIN = 'OriginList',
  PATIENT_STATUS = 'PatientStatusList',
  PROCEDURE = 'ProcedureList',
  TEST = 'TestList',
  SERVICE = 'ServiceList',
  THERAPEUTIC_CELLING = 'TherapeuticCeilingList',
  TREATMENT = 'TreatmentList',
  VISIT = 'VisitOptionList',
  LANGUAGE_BARRIER_LIST = 'LanguageBarrierList',
  PASSIVE_SITTING = 'PassiveSittingList',
  GENERIC_LIST = 'GenericList',
  ACCESS_CONTROL = 'AccessControlList',
  POC_LIST = 'PocList',
  CARE_PLAN_OBJECTIVE_LIST = 'CarePlanObjectiveList',
  EPIS = 'EpisList',
  HOBBIES_LIST = 'HobbiesList',
  CATHETERS = 'CatheterList',
  CLINICAL_ROUTES = 'ClinicalRouteList',
  CLINICAL_ROUTE_LOCATIONS = 'ClinicalRouteLocationList',
  NURSE_CALL_LIST = 'NurseCallList',
  ALARM_STATUS_LIST = 'AlarmStatusList',
  UNDEFINED = "Undefined"
}

export enum E_MasterListItemChanges {
  Add = 'add',
  Edit = 'edit',
  Delete = 'delete',
}
